/**
 * COLESCOMEX motion vocabulary. One brand timing system shared by CSS (tokens.css),
 * the logo assembly, the globe director and the 3D scenes.
 *   reveal    — content entering reading position
 *   enter     — a scene or layer arriving
 *   integrate — fragments organising into one system (the brand gesture)
 *   signal    — restrained cyan status pulse
 *   settle    — final micro-adjustment into rest
 */
export const DURATION = { settle: 420, reveal: 760, enter: 980, integrate: 1400, signal: 2400 } as const;

export const clamp01 = (value: number) => (value < 0 ? 0 : value > 1 ? 1 : value);
export const lerp = (from: number, to: number, t: number) => from + (to - from) * t;
/** Remaps `value` from [start, end] to [0, 1], clamped. A zero-width range is a step at `end`. */
export const range = (value: number, start: number, end: number) => (end === start ? (value >= end ? 1 : 0) : clamp01((value - start) / (end - start)));

export const EASE = {
  standard: (t: number) => 1 - Math.pow(1 - t, 3),
  integrate: (t: number) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2),
  settle: (t: number) => 1 - Math.pow(1 - t, 4),
  signal: (t: number) => 1 - Math.pow(1 - t, 2),
} as const;
